import { DeliveryServices } from '@/domain/models/DeliveryService';
import { DASHBOARD_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

interface Interface {
  list: () => Promise<DeliveryServices>;
}

export class DeliveryServiceService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(): Promise<DeliveryServices> {
    return await this.restClient.get<DeliveryServices>(
      `${DASHBOARD_API_ORIGIN}/api/enterprise/delivery-services` as const
    );
  }
}
